import { useAtomValue } from "jotai";

import {
  ActionsCloseButton,
  FloatingToolbar,
  IconAction,
} from "../../../components/PageView/PageViewTable/SharedToolbar/SharedSelectedRecordsActions";
import useBulkDeleteRecords from "../../../api/api-hooks/records/useBulkDeleteRecords";
import { FileInterface } from "../../../types/RecordInterfaces";
import { downloadFile } from "../../../utils/FileUtils";
import { IsMobileAtom } from "../../../App";
import { FileRecord } from "../Library";

interface Props {
  selectedFiles: FileRecord[];
  onClear: () => void;
}

const LibraryFloatingToolbar = ({ selectedFiles, onClear }: Props) => {
  const isMobile = useAtomValue(IsMobileAtom);
  const { bulkDeleteRecords, confirmBulkDelete } = useBulkDeleteRecords();

  async function handleDelete() {
    const confirmed = await confirmBulkDelete();

    if (!confirmed) return;

    bulkDeleteRecords({
      moduleAPIName: "Files",
      payload: { Ids: selectedFiles.map((f) => f.recordID) },
    });
  }

  async function handleDownloadFilesInWithLimit(
    files: FileInterface[],
    limit: number
  ) {
    let i = 0;

    async function next() {
      if (i >= files.length) return;
      const currentIndex = i++;
      try {
        await downloadFile(files[currentIndex]);
      } catch (err) {}
      return next(); // Continue with the next task
    }

    // Start `limit` number of concurrent tasks
    await Promise.all(Array.from({ length: limit }, next));
  }

  async function handleDownload() {
    const files = selectedFiles.map((f) => f.file);

    await handleDownloadFilesInWithLimit(files, 5);
  }

  return (
    <FloatingToolbar disableSidebarCheck={true}>
      <ActionsCloseButton onClear={onClear} length={selectedFiles?.length} />
      <div
        className="tw:flex tw:items-center tw:ml-2"
        style={{ overflowX: "auto" }}
      >
        {/** //TODO: Add this. */}
        {/* <IconAction
          onClick={() => {}}
          icon=""
          title="AI Chat"
          isMobile={isMobile}
        /> */}
        <IconAction
          onClick={handleDownload}
          icon="download"
          title="Download"
          isMobile={isMobile}
        />
        <IconAction
          onClick={handleDelete}
          icon="delete"
          title="Delete"
          isMobile={isMobile}
        />
      </div>
    </FloatingToolbar>
  );
};

export default LibraryFloatingToolbar;
